export const catalogKeys = {
    videos: (params) => ['public-videos', params],
    video: (slug) => ['public-video', slug],
    categories: ['public-categories'],
};
